<template>
  <div>

    <!-- For now remove "Uporabi shranjena iskanja" if not authenticated
    <div class="mb-10 mt-11 flex justify-center">
      <template v-if="!headerSetupData.isAuthenticated">
        <v-login
          :login-show="false"
        :facebook-login-route="headerSetupData.facebookLoginRoute"
            :google-login-route="headerSetupData.googleLoginRoute"
          :login-error="headerSetupData.loginError"
          :login-post-route="headerSetupData.loginPostRoute"
          :register-route="headerSetupData.registerRoute"
          :forgot-password-route="headerSetupData.forgotPasswordRoute"
          :csrf-token="headerSetupData.csrfToken"
          v-if="!headerSetupData.isAuthenticated"
        >
          <template v-slot:trigger>
            <a class="button button--salmon-hover group">
              <v-icon icon="heart" class="group-hover:hidden"></v-icon>
              <v-icon icon="heart-solid" class="hidden group-hover:flex"></v-icon>
              <label>Uporabi shranjena iskanja</label>
            </a>
          </template>
        </v-login>
      </template>

      <template v-else>
        <a href="#" class="button button--salmon-hover group">
          <v-icon icon="heart" class="group-hover:hidden"></v-icon>
          <v-icon icon="heart-solid" class="hidden group-hover:flex"></v-icon>
          <label>Uporabi shranjena iskanja</label>
        </a>
      </template>
    </div>
      -->
    <div class="mb-10 mt-11 flex justify-center" v-if="headerSetupData.isAuthenticated">
        <a href="#" class="button button--salmon-hover group">
          <v-icon icon="heart" class="group-hover:hidden"></v-icon>
          <v-icon icon="heart-solid" class="hidden group-hover:flex"></v-icon>
          <label>Uporabi shranjena iskanja</label>
        </a>
    </div>

    <div class="mt-10 flex flex-col items-center justify-center lg:flex-row">
      <div class="mb-4 text-form font-medium text-white lg:mb-0 lg:mr-6 lg:text-xs">
        Bi radi objavili oglas?
      </div>
      <div class="flex items-center gap-4 lg:gap-6">
        <template v-if="headerSetupData.isAuthenticated">
          <a :href="headerSetupData.createListingRouteKauf"
            class="button button--white shadow lg:shadow-none">
            <v-icon icon="banknotes"></v-icon>
            Prodaja
          </a>

          <a :href="headerSetupData.createListingRouteMiete"
            class="button button--white shadow lg:shadow-none">
            <v-icon icon="buy-house"></v-icon>
            Oddaja
          </a>
        </template>

        <template v-else>
          <v-login
            :login-show="false"
            :facebook-login-route="headerSetupData.facebookLoginRoute"
            :google-login-route="headerSetupData.googleLoginRoute"
            :login-error="headerSetupData.loginError"
            :login-post-route="headerSetupData.loginPostRoute"
            :register-route="headerSetupData.registerRoute"
            :forgot-password-route="headerSetupData.forgotPasswordRoute"
            :csrf-token="headerSetupData.csrfToken"
            v-if="!headerSetupData.isAuthenticated"
          >
            <template v-slot:trigger>
              <a class="button button--white shadow lg:shadow-none">
                <v-icon icon="banknotes"></v-icon>
                Prodaja
              </a>
            </template>
          </v-login>

          <v-login
            :login-show="false"
            :facebook-login-route="headerSetupData.facebookLoginRoute"
            :google-login-route="headerSetupData.googleLoginRoute"
            :login-error="headerSetupData.loginError"
            :login-post-route="headerSetupData.loginPostRoute"
            :register-route="headerSetupData.registerRoute"
            :forgot-password-route="headerSetupData.forgotPasswordRoute"
            :csrf-token="headerSetupData.csrfToken"
            v-if="!headerSetupData.isAuthenticated"
          >
            <template v-slot:trigger>
              <a class="button button--white shadow lg:shadow-none">
                <v-icon icon="buy-house"></v-icon>
                Oddaja
              </a>
            </template>
          </v-login>


        </template>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainSearchLandingActions",

  props: {
    headerSetupData: {
      type: Object,
      required: true,
    }
  },
};
</script>
